// components/feedbackTypes.js
//
// The kinds of feedback, as the backend keeps them (feedback/models.py),
// for every form that sends feedback: the feedback dialog and the error
// screen. "feature" holds features and improvements alike. Both ask a
// visitor without an account for an address to reply to, if they like.

export const FEEDBACK_TYPES = [
  { value: "bug", label: "Bug Report" },
  { value: "question", label: "Question" },
  { value: "feature", label: "Suggestion" },
  { value: "other", label: "Other" },
];

/** Enough of an address to catch a typo; the backend checks it properly. */
export const looksLikeEmail = (value) =>
  /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
